import React, {useEffect, useRef, useState} from "react";
import IMG from "../../../constants/image";
import './style.css'
import {uploadImage} from "../../../network/api";
import cn from "classnames";

const ImageUpload = ({onUpload, images, viewOnly, thumbIndex, setThumbnailIndex, isDocOther}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errors, setErrors] = useState([]);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setSelectedFiles(images || []);
  }, [images]);

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const newErrors = [];
    files.forEach((file) => {
      if (file.size > 25 * 1024 * 1024) {
        newErrors.push(`${file.name} vượt quá kích thước tối đa 25MB.`);
        return;
      }
      if (!['image/jpeg', 'image/jpg', 'image/png', 'image/heic'].includes(file.type)) {
        newErrors.push(`${file.name} không phải định dạng ảnh hợp lệ.`);
        return;
      }
    });
    let uploadData;
    try {
      uploadData = await uploadImage({files: files});
    } catch (e) {
      newErrors.push(e?.message || 'Dung lượng ảnh vượt quá giới hạn cho phép. Vui lòng kiểm tra lại.');
      setErrors(newErrors);
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }
    const allFiles = selectedFiles.concat(uploadData);

    if (allFiles?.length > 5) {
      newErrors.push('Số lượng ảnh tối đa là 5 ảnh.');
      setErrors(newErrors);
      if (fileInputRef.current) fileInputRef.current.value = '';
      return;
    }

    setSelectedFiles(allFiles);
    setErrors(newErrors);
    onUpload && onUpload(allFiles);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const removeFile = (index) => {
    const newFiles = [...selectedFiles];
    if (index < thumbIndex) {
      setThumbnailIndex(thumbIndex - 1);
    } else if (index === thumbIndex) {
      setThumbnailIndex(0);
    }

    newFiles.splice(index, 1);
    setSelectedFiles(newFiles);
    onUpload && onUpload(newFiles);
  };

  const handleChooseThumbnail = (index) => {
    setThumbnailIndex(index)
  }

  const renderFile = (file) => {
    const getPreviewUrl = (file) => {
      if (file instanceof File || file instanceof Blob) {
        return URL.createObjectURL(file);
      } else if (file) return file?.url;
      return ''; // hoặc một URL placeholder mặc định
    };
    return (<img
      src={getPreviewUrl(file)}
      alt='preview'
      className="w-full h-32 object-cover rounded-lg"
    />)
  }

  return (<div className="">
    {!viewOnly && <div className="mb-4">
      <label
        htmlFor="file-upload"
        className="wrapper-upload"
      >
        <div className="flex flex-col items-center justify-center">
          <img src={IMG.imageUpload} alt='imageUpload'/>
          <p className="text-upload">
            Chọn ảnh
          </p>
        </div>
        <input
          id="file-upload"
          type="file"
          className="hidden"
          accept=".jpg,.jpeg,.png,.heic"
          multiple
          onChange={handleFileChange}
          ref={fileInputRef}
          aria-label="File upload input"
        />
      </label>
      <p className="desc-upload">
        {isDocOther ? 'Lưu ý: Tối đa 5 tệp và chỉ cho phép các định dạng .pdf, .jpg, jpeg, .png với kích thước tệp tối đa 5MB' : 'Lưu ý: Chỉ cho phép các định dạng .jpg, jpeg, .png với kích thước ảnh tối đa 5MB'}
      </p>
    </div>}

    {errors.length > 0 && !viewOnly && (<div className="mb-4 p-4 bg-red-100 rounded-lg text-sm" role="alert">
      <p className="font-bold text-[#FF0019] mb-2">Chú ý:</p>
      <ul className="list-disc pl-5 marker:text-[#FF0019]/70">
        {errors.map((error, index) => (<li key={index} className="text-[#FF0019]/70">
          {error}
        </li>))}
      </ul>
    </div>)}

    {selectedFiles.length > 0 && (
      <div className='bg-[#FAFAFC] rounded-[10px] px-4 py-2 space-y-[10px]'>
        {!isDocOther && <div>Chọn 1 hình làm ảnh đại diện</div>}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
          {selectedFiles.map((file, index) => (<div
            key={index}
            className="relative flex flex-col gap-2 items-center bg-gray-100 p-2 rounded-lg transition-transform transform"
          >
            {!isDocOther && <div
              className={cn("flex justify-center items-center w-[18px] h-[18px] rounded-full border-2 border-green-700 text-center cursor-pointer", index === thumbIndex && 'bg-green-700')}
              onClick={() => handleChooseThumbnail(index)}
            >
              {index === thumbIndex && <img className='w-2' src={IMG.icon.check} alt="check"/>}
            </div>}
            {renderFile(file)}
            <div className="w-full">
              <div className="flex justify-between text-xs text-gray-500 mb-1">
                <span>{`Hình ${index + 1}`}</span>

                {!viewOnly && <button
                  className='flex justify-center items-center bg-[#F8C518] h-[14px] text-[10px] rounded-md px-2 text-black'
                  onClick={(e) => {
                    e.preventDefault();
                    removeFile(index)
                  }}
                >
                  Xoá
                </button>}
              </div>
            </div>
          </div>))}
        </div>
      </div>
    )}
  </div>);
};

export default ImageUpload;
